const actionPrefix = "@@contentful"
export const GET_PAGE = `${actionPrefix}/GET_PAGE`
export const GET_COMPLETE = `${actionPrefix}/GET_COMPLETE`
export const GET_ERROR = `${actionPrefix}/GET_ERROR`
